import {Injectable} from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from './auth.service';
import {Observable} from 'rxjs';

@Injectable()
export class AuthGuardService  {

	constructor(
		private auth: AuthService,
		private router: Router,
	) {
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		const queryParams = this.getQueryParams(state.root);
		const token = queryParams['token'];
		if (token) {
			localStorage.setItem('access_token', token);
			sessionStorage.setItem('arrivedWithToken', 'true');
			localStorage.setItem('expires_at', `${Date.now() + 3600000}`);
			return true;
		} else {
			this.auth.renewTokens();

			if (!this.auth.isAuthenticated()) {
				localStorage.setItem('authRedirect', state.url);
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		}
	}

	private getQueryParams(route: ActivatedRouteSnapshot): { [key: string]: string } {
		let queryParams = { ...route.queryParams };
		while (route.firstChild) {
			route = route.firstChild;
			queryParams = { ...queryParams, ...route.queryParams };
		}
		return queryParams;
	}

	async sleep(msec) {
		return new Promise(resolve => setTimeout(resolve, msec));
	}
}
